;(function(){
  // Se siamo già passati di qui, usciamo subito
  if (window.__combinazioniDone) return;
  window.__combinazioniDone = true;

  // Prendo le variabili che hai impostato nel template prodotto
  const modelloTag     = window.currentProductTag;
  const productHandle  = window.currentProductHandle;
  const productBrand   = window.currentProductBrand;
  const root = window.Shopify?.routes?.root || "/";
  const english = document.documentElement.lang.toLowerCase().startsWith("en");

  // Se non c'è MODELLO_, esco subito
  if (!modelloTag) {
    const c = document.getElementById('combinazioni-grid');
    if (c) c.innerHTML = `
      <div class="no-products-message">
        <p>${english ? "No other colours available." : "Non ci sono altri colori disponibili."}</p>
      </div>`;
    return;
  }

  // Adesso carico i prodotti UNA SOLA VOLTA
  const perRequest = 50;
  let currentPage = 1;
  let allFiltered = [];
/*
  function getImg(p) {
    if (p.images && p.images.length) {
      const u = p.images[0].src.split('?')[0];
      return `${u}?width=200&height=200&crop=center`;
    }
    return 'https://via.placeholder.com/200x200?text=Immagine+non+disponibile';
  }

  function render(products) {
    const container = document.getElementById('combinazioni-grid');
    if (!container) return;
    if (!products.length) {
      document.querySelector('.combinazioni-container')?.style.setProperty('display','none');
      return;
    }
    container.innerHTML = products.map(p => `
      <div class="combinazione-card">
        <a href="/products/${p.handle}" class="combinazione-link">
          <div class="combinazione-img-container">
            <img src="${getImg(p)}" alt="${p.title}" loading="lazy" class="combinazione-img">
          </div>
          <div class="combinazione-info">
            <h3 class="combinazione-titolo">${p.title}</h3>
          </div>
        </a>
      </div>
    `).join('');
  }
    */

  function getImg(p) {
  // 1) vecchia struttura (products.json)
  if (p?.images?.length) {
    const src = (p.images[0].src || p.images[0]).toString();
    return img200(src);
  }

  // 2) struttura suggest: spesso p.image è già una URL
  if (p?.image) return img200(p.image);

  // 3) altre varianti comuni
  if (p?.featured_image?.url) return img200(p.featured_image.url);
  if (typeof p?.featured_image === 'string') return img200(p.featured_image);

  // 4) placeholder
  return 'https://via.placeholder.com/200x200?text=Immagine+non+disponibile';
}

function img200(url) {
  if (!url) return 'https://via.placeholder.com/200x200?text=Immagine+non+disponibile';
  const base = url.split('?')[0];

  // Se è un URL CDN Shopify, puoi usare parametri width/height/crop
  // (se non li supporta, ignora e mostrerà l’immagine originale).
  return `${base}?width=200&height=200&crop=center`;
}

function escapeHtml(s) {
  return String(s ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function render(products) {
  const container = document.getElementById('combinazioni-grid');
  if (!container) return;

  if (!products.length) {
    document.querySelector('.combinazioni-container')?.style.setProperty('display','none');
    return;
  }

  container.innerHTML = products.map(p => `
    <div class="combinazione-card">
      <a href="${root}products/${encodeURIComponent(p.handle)}" class="combinazione-link">
        <div class="combinazione-img-container">
          <img src="${escapeHtml(getImg(p))}" alt="" width="200" height="200" loading="lazy" decoding="async" class="combinazione-img">
        </div>
        <div class="combinazione-info">
          <h3 class="combinazione-titolo">${escapeHtml(p.title)}</h3>
        </div>
      </a>
    </div>
  `).join('');
}


/*
  function load(page) {
   // fetch(`/collections/${productBrand}/products.json?limit=${perRequest}&page=${page}`)
    fetch(`/search/suggest.json?q=tag:${modelloTag}&resources[type]=product&resources[limit]=10`)
      .then(r=>r.json()).then(data=>{
        const filt = data.products.filter(p =>
          p.tags.includes(modelloTag) && p.handle !== productHandle
        );
        allFiltered = allFiltered.concat(filt);
        if (data.products.length === perRequest) {
          load(++currentPage);
        } else {
          render(allFiltered);
        }
      })
      .catch(()=>{
        const c = document.getElementById('combinazioni-grid');
        if (c) c.innerHTML = `<p>${english ? "Unable to load other colours. Please try again later." : "Errore nel caricamento degli altri colori."}</p>`;
      });
  }
      */

  function load() {
  const c = document.getElementById('combinazioni-grid');

  // NB: encodeURIComponent è fondamentale (tag con spazi, underscore, ecc.)
  const q = `tag:${modelloTag}`;
  const url =
    `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=${perRequest}`;

  fetch(url, { credentials: 'same-origin' })
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then(data => {
      // Shopify suggest: products stanno qui (non in data.products)
      const products = data?.resources?.results?.products || [];

      // Qui NON serve più filtrare per tag: lo fa già la query.
      // Ma lo lascio come safety net in caso di indicizzazione “larga”.
      const filt = products.filter(p =>
        (p.tags ? p.tags.includes(modelloTag) : true) &&
        p.handle !== productHandle
      );

      render(filt);
    })
    .catch(() => {
      if (c) c.innerHTML = `<p>${english ? "Unable to load other colours. Please try again later." : "Errore nel caricamento degli altri colori."}</p>`;
    });
}


  // Fetch related colours as the section approaches the viewport.
  function observeCombinations() {
    const target = document.getElementById('combinazioni-grid');
    if (!target) return;
    if (!('IntersectionObserver' in window)) { load(); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        observer.disconnect();
        load();
      }
    }, { rootMargin: '300px' });
    observer.observe(target);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCombinations, { once: true });
  } else {
    observeCombinations();
  }

})();
document.addEventListener("DOMContentLoaded", function () {
  // Seleziona il contenuto da spostare
  var combinazioni = document.querySelector(".combinazioni-container");

  // Seleziona il contenitore dei pulsanti d'acquisto
  var buyButtons = document.querySelector("buy-buttons");

  if (combinazioni && buyButtons) {
    // Inserisce il blocco sopra il componente buy-buttons
    buyButtons.parentNode.insertBefore(combinazioni, buyButtons);
  }
});

